import { EventTrackingValue } from '../../../../team-apis/core/event-tracking';
import { MultiClickShapeToolHelper } from '../shared/tool-helpers/multi-click-shape-tool-helper';

export class RectangleToolHelper extends MultiClickShapeToolHelper {
  protected override removeLastPlacedSubpoint(
    eventTrackingValue: EventTrackingValue,
  ) {
    this.cancel(eventTrackingValue);
  }
}
